import {
  closeInfoPopup,
  toggleInfoPopup,
} from '../shared/infoPopup/infoPopupControllerActions';
import type { RatingScreenModel } from './RatingScreenModelScreen';

export class RatingScreenController {
  constructor(private readonly model: RatingScreenModel) {}

  handleInfoButtonClick = () => {
    toggleInfoPopup(this.model);
  };

  handleInfoClose = () => {
    closeInfoPopup(this.model);
  };

  handleGoBack = () => {
    this.model.onGoBack?.();
  };
}
